/*
 * Copyright (c) Nexign, JSC, 2023.
 */
/**
 * Constants for Bills
 *
 * @author Evgeniy Naumov
 * @version 1.25.0
 * @since 1.25.0
 */

/*
 * -------------------------------------------
 *           ACTIONS
 * -------------------------------------------
 */

export const BILLS_INIT_ONBOARDING = '@@b2b_portal_ui/bills/INIT_ONBOARDING';
